import { getInlineFilterOptions } from './inlineFilterOptions';
import type { SerpFilterOptionView } from '../model/types';

export const OPERATORS_FILTER_INLINE_LIMIT = 5;

export function getOperatorsFilterInlineOptions(
  options: readonly SerpFilterOptionView[],
  pinnedKeys: ReadonlySet<string>,
  expanded: boolean,
): SerpFilterOptionView[] {
  return getInlineFilterOptions(options, pinnedKeys, expanded ? options.length : OPERATORS_FILTER_INLINE_LIMIT);
}
